import generateUtilityClasses from '@mui/utils/generateUtilityClasses';
const boxClasses = generateUtilityClasses('MuiBox', ['root']);
export default boxClasses;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@mui/material/Box/boxClasses.js
// module id = 703
// module chunks = 0